import Vue from 'vue'

export default {
    listarGrupo: () => {
        return Vue.prototype.$http("/graphql", {
            data:{
              query: `{
                listarGrupo {
                  id
                  descricao
                  exibir
                  ordem
                }
              }`
            }
        })
    },
    listarGrupoByDescricao: (descricao) => {
      return Vue.prototype.$http("/graphql", {
          data:{
            query: `{
              listarGrupo(descricao: "${descricao}") {
                id
                descricao
                exibir
                ordem
              }
            }`
          }
      })
  },
    criarGrupo: (grupoInput) => {
      return Vue.prototype.$http("/graphql", {
        data:{
          query: `mutation{
            criarGrupo(data:{
              descricao: "${grupoInput.descricao}"
              exibir: ${grupoInput.exibir}
              ordem: ${grupoInput.ordem}
            }){
              id
              descricao
              exibir
              ordem
            }
          }`
        }
      })
    },
    atualizarGrupo: (grupoInput) => {
      return Vue.prototype.$http("/graphql", {
        data:{
          query: `mutation{
            atualizarGrupo(id: ${grupoInput.id}, data:{
              descricao: "${grupoInput.descricao}"
              exibir: ${grupoInput.exibir}
              ordem: ${grupoInput.ordem}
            }){
              id
              descricao
              exibir
              ordem
            }
          }`
        }
      })
    },
    deletarGrupo: (grupoId) => {
      return Vue.prototype.$http("/graphql", {
        data:{
          query: `mutation{
            deletarGrupo(id: ${grupoId})
          }`
        }
      })
    },
}
